export default [
  {
    label: 'transactions.overview_transaction_id_column_heading',
    field: 'transactionId',
    type: 'number',
    filterable: true,
    sortable: true,
    placeholder: ' ',
    agentOnly: true,
  },
  {
    label: 'transactions.overview_creation_date_column_heading',
    field: 'transactionStart',
    filterable: true,
    sortable: true,
    placeholder: ' ',
    type: 'string',
  },
  {
    label: 'transactions.overview_type_column_heading',
    field: 'subscriptionChargeTypeId',
    type: 'string',
    filterable: true,
    sortable: true,
    placeholder: ' ',
    customerOnly: true,
  },
  {
    label: 'transactions.overview_vas_code_column_heading',
    field: 'resellingRequestedContent',
    filterable: true,
    sortable: true,
    placeholder: ' ',
    agentOnly: true,
  },
  {
    label: 'transactions.overview_service_column_heading',
    field: 'serviceDescription',
    type: 'string',
    filterable: true,
    sortable: true,
    placeholder: ' ',
  },
  {
    label: 'transactions.overview_provider_column_heading',
    field: 'partnerName',
    filterable: true,
    sortable: true,
    placeholder: ' ',
    filterDropdown: true,
    filterOptions: [] /* this.getUniqueTAListPartnerNames, /* ['bupa1-name', 'TBup_CP_19'], */,
  },
  {
    label: 'transactions.overview_status_column_heading',
    field: 'stateDescription',
    filterable: true,
    sortable: true,
    placeholder: ' ',
    filterDropdown: true,
    filterOptions: [],
    agentOnly: true,
  },
  {
    label: 'transactions.overview_price_column_heading',
    field: 'price',
    filterable: true,
    sortable: true,
    placeholder: ' ',
    customerOnly: true,
  },
  {
    label: 'transactions.overview_action_column_heading',
    filterable: false,
    sortable: false,
    placeholder: ' ',
  },
];
